import IComponent from "components/commons/IComponent";
import "./PanelBase.scoped.css";
import React from "react";
import * as projection from "@arcgis/core/geometry/projection.js";
import IdentifyManager from "components/MapViews/IdentifyManager";
import geometryTools from "utils/geometryTools";
import StreetViewPoint from "./ic_streetview.png";
class GoogleStreetView extends IComponent {
  streetViewContainer = undefined;
  mPanorama = undefined;
  mStreetViewService = undefined;
  mapClickListener = undefined;
  streetViewGLayer = undefined;
  constructor(props) {
    super(props);
    this.streetViewContainer = React.createRef();
    this.streetViewGLayer = geometryTools.createGraphicsLayerById(
      "GoogleStreetViewPointer",
      props.mapView.map
    );
  }
  componentDidMount() {
    console.debug("Google Street View script is loaded?", window.google?.maps);
    if (!document.getElementById("GoogleStreetAPIScript")) {
      let scriptTag = document.createElement("SCRIPT");
      scriptTag.id = "GoogleStreetAPIScript";
      scriptTag.onload = function() {
        console.debug(
          "Google Street View script is loaded?",
          window.google?.maps
        );
        this.initGoogleStreetView();
      }.bind(this);
      scriptTag.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtBg7UpJY6ZOhJvMtDmaORSj-fe76w3bM&signed_in=true";
      let head = document.querySelector("HEAD");
      head.appendChild(scriptTag);
    } else this.initGoogleStreetView();
    IdentifyManager.enableIdentify = false;
  }
  componentWillUnmount() {
    IdentifyManager.enableIdentify = true;
    this.mapClickListener.remove();
    this.streetViewGLayer.removeAll();
  }
  async initGoogleStreetView() {
    await projection.load();
    this.mStreetViewService = new window.google.maps.StreetViewService();
    this.mPanorama = new window.google.maps.StreetViewPanorama(
      this.streetViewContainer.current,
      {
        addressControl: false,
        fullscreenControl: false,
      }
    );
    this.mapClickListener = this.props.mapView.on(
      "click",
      function(evt) {
        this.setStreetViewLocation(evt.mapPoint);
      }.bind(this)
    );
    this.mPanorama.addListener(
      "position_changed",
      this.updateMapPoint.bind(this)
    );
    this.mPanorama.addListener("pov_changed", this.updateMapPoint.bind(this));

    let mapCenter = this.props.mapView.extent.center.clone();
    this.setStreetViewLocation(mapCenter);
  }
  setStreetViewLocation(mapPoint) {
    let mMapPoint = projection.project(mapPoint, {
      wkid: 4326,
    });

    this.mStreetViewService.getPanorama(
      { location: { lat: mMapPoint.y, lng: mMapPoint.x } },
      function(pStreetViewPanoramaData, pStreetViewStatus) {
        if (pStreetViewStatus == window.google.maps.StreetViewStatus.OK) {
          this.mPanorama.setPosition(pStreetViewPanoramaData.location.latLng);
        }
      }.bind(this)
    );
  }
  updateMapPoint() {
    var mAngle = this.mPanorama.getPov().heading;
    var mLat = this.mPanorama.getPosition().lat();
    var mLng = this.mPanorama.getPosition().lng();
    this.streetViewGLayer.removeAll();
    let mapPoint = new geometryTools.Point({ x: mLng, y: mLat });
    let symbol = {
      type: "picture-marker",
      url: StreetViewPoint,
      width: 119,
      height: 212,
      angle: mAngle,
    };
    this.streetViewGLayer.add(
      new geometryTools.Graphic({
        geometry: mapPoint,
        symbol,
      })
    );
  }
  render() {
    return (
      <div style={{ minHeight: "350px", height: "100%" }}>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Google Street View</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>

        <div className="PanelContent">
          <div
            style={{ minHeight: "350px", height: "100%" }}
            ref={this.streetViewContainer}
          >
            <span className="icn_loading" /> Initializing Google Street View,
            please wait...
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleStreetView;
